import { AxiosInstance } from "axios"
import { ServerMemoryTypes } from "./serverMemoryTypes"

export enum SupportServerMemoryQuery {
    MEMORY_USAGE = "MEMORY_USAGE",
}

export type ServerMemoryUsageResponse = Readonly<{
    memoryUsage: {
        memoryTypes: Array<ServerMemoryTypes>
    }
}>

export async function fetchServerMemoryUsage(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServerMemoryUsageResponse> {
    const { data } = await axios.get("/memory/usage", {
        signal,
    })
    return data
}
